module.exports = __webpack_public_path__ + "img/category-skill-game.814b5898.png";